import styled from 'styled-components';

export const NoPassengers = styled.div`
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    padding: 16px 0;
    color: #404b5a;
`;

export const PassengerItem = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 16px;
    background-color: #fff;
    border: 1px solid #e4e7e8;
    margin-bottom: 16px;

    @media (max-width: 599px) {
        padding: 8px;
    }
`;

export const PassengerInfoBlock = styled.div`
    display: flex;
    flex-direction: column;
`;

export const PassengerName = styled.div`
    font-weight: bold;
    font-size: 18px;
    color: #404b5a;
`;

const InfoItem = styled.div`
    color: #404b5a;
    font-size: 14px;

    & > span {
        color: #9da8ae;
        font-size: 14px;
    }
`;

export const PassengerCitizenship = styled(InfoItem)``;

export const PassengerGender = styled(InfoItem)``;

export const PassengerBirthday = styled(InfoItem)``;

export const PassengerDocument = styled(InfoItem)``;

export const PassengerEmail = styled(InfoItem)``;

export const PassengerPhone = styled(InfoItem)``;

export const ButtonsBlock = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;

    @media (max-width: 599px) {
        margin-top: 8px;
    }
`;

const Button = styled.button`
    border: none;
    border-radius: 8px;
    box-shadow: none;
    font-size: 16px;
    color: #fff;
    padding: 8px 16px;
    font-weight: bold;
    cursor: pointer;

    @media (max-width: 599px) {
        padding: 8px 12px;
        font-size: 14px;
    }
`;

export const ChooseButton = styled(Button)`
    margin-right: 16px;
    background-color: #00ddff;

    @media (max-width: 599px) {
        margin-right: 8px;
    }
`;

export const DeleteButton = styled(Button)`
    background-color: #c62828;
`;
